import { StepsLayout } from "@rapid/components/layout/StepsLayout";
import LoadingScreen from "@rapid/components/LoadingScreen";
import { useDeployContext } from "@rapid/contexts/DeployContext";

export function DeployLayout({
    Sidebar,
    VisualArea,
    BottomContent
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
    BottomContent?: React.ReactNode;
}) {
    const { loading } = useDeployContext();

    if (loading) {
        return <LoadingScreen />;
    }

    return <StepsLayout Sidebar={Sidebar} VisualArea={VisualArea} BottomContent={BottomContent} />;
}
